import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { ADMIN_SUB_CATEGORIES_API_PATHS } from '../constants/sub-categories-api-paths.constants';

type SubCategoryPosition = {
  id: string;
  position: number;
};

type UseUpdateSubCategoriesPositionsResult = {
  updatePositions: (subCategories: SubCategoryPosition[]) => Promise<boolean>;
  isSubmitting: boolean;
};

export function useUpdateSubCategoriesPositions(): UseUpdateSubCategoriesPositionsResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updatePositions = async (subCategories: SubCategoryPosition[]): Promise<boolean> => {
    setIsSubmitting(true);

    try {
      await HttpClient.patch(ADMIN_SUB_CATEGORIES_API_PATHS.UPDATE_SUB_CATEGORIES_POSITIONS, { subCategories });

      enqueueSnackbar('Les positions ont été mises à jour', { variant: 'success' });
      return true;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la mise à jour des positions'),
        { variant: 'error' }
      );
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { updatePositions, isSubmitting };
}
